<template>
  <div id="chart">
    <apexchart type="bar" height="250" :options="chartOptions" :series="series"></apexchart>
  </div>
</template>
<script>
  import VueApexCharts from 'vue-apexcharts'
  export default {
    name: "Age",
    props: ['getseries'],
    components: {
      apexchart: VueApexCharts,
    },
    data() {
      return {

        series: [{
          name: '',
          data: this.getseries,
        }],

        chartOptions: {
          chart: {
            type: 'bar',
            height: 350,
            stacked: true,
            toolbar: {
              show: false
            },
            zoom: {
              enabled: false
            }
          },
          responsive: [{
            breakpoint: 480,
            options: {
              legend: {
                position: 'bottom',
                offsetX: -10,
                offsetY: 0
              }
            }
          }],
          plotOptions: {
            bar: {
              horizontal: false,
            },
          },
          xaxis: {
            type: 'datetime',
            categories: ['01/01/2011 GMT', '01/02/2011 GMT', '01/03/2011 GMT', '01/04/2011 GMT', '01/05/2011 GMT', '01/06/2011 GMT'],
          },
          legend: {
            position: 'right',
            offsetY: 40
          },
          fill: {
            opacity: 1
          }
        },

      }
    },
    created() {

    },
  }
</script>

<style lang="scss" scoped>

</style>
